import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import TitleBar from "../../components/popUp/TitleBar";
import {Card, Col, Row} from "react-bootstrap";
import CardView from "../../components/layout/CardView";
import {getMapCards, getMapCardsAnon} from "../../api/apiClient";
import styled from "styled-components";
import DashCardView from "../../components/layout/DashCardView";

const StyledStatusContent = styled.div`
  background-color: var(--color-content-container);
  border-radius: 10px;
  border: 1px solid var(--color-light-border);
  height: ${(props) => props.height || "100%"};
`;

const StyledStatusContentBody = styled.div`
`;

const StyledStatusContentBodyItem = styled.div`
  border-radius: 10px;
  border: 1px solid var(--color-light-border);
`;

const StyledFireContent = styled.div`
  height: ${(props) => props.height || "100%"};
    //max-height: ${(props) => props.height || "100%"};
  //overflow: auto;
  overflow: hidden;
`;

const StyledFireContentBody = styled.div`
  height: ${(props) => props.height || "100%"};
  max-height: ${(props) => props.height || "100%"};
  //overflow: auto;
  padding: 5px;
  margin-top: auto !important;
  margin-bottom: auto !important;
  display: grid;
  //gap: 5px;
`;

const DashFailureCards = ({
                            propAtdrcId = '',
                            propAnonAPI = false
                          }) => {

  const [cardData, setCardData] = useState();

  const [stTimeRefresher, setTimeRefresher] = useState(null);
  const [stRefreshSeed, setRefreshSeed] = useState(0);

  useEffect(() => {
    updateData();

    let timeInterval = setInterval(updateCycle, 10000);
    setTimeRefresher(timeInterval);

    return () => {
      console.log("unmount");
      console.log(stTimeRefresher)
      clearInterval(stTimeRefresher);
    };

  }, [])

  useEffect(() => {
    updateData();
  }, [stRefreshSeed, propAtdrcId])

  const updateCycle = () => {
    let rand = Math.random();
    console.log(`update 10s! ${rand}`);
    setRefreshSeed(rand);
    // updateCardList();
    // updateLabelList();
    // updateBackButton();
    // updateMarker();
  }

  const updateData = () => {
    let atdrcId = ''
    if (propAtdrcId != '0') {
      atdrcId = propAtdrcId
    }

    if (propAnonAPI) {
      getMapCardsAnon(atdrcId).then(res => {
        console.log(res);
        setCardData(res.data.data);
      })
    } else {
      getMapCards(atdrcId).then(res => {
        console.log(res);
        setCardData(res.data.data);
      })
    }
  }

  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const StatusContent = ({children, height}) => {
    return (
        <StyledStatusContent className={`${propAnonAPI ? "status" : ''}`}
                             height={height}
        >
          {children}
        </StyledStatusContent>
    );
  };

  const StatusContentBody = ({children}) => {
    return (
        <StyledStatusContentBody>
          {children}
        </StyledStatusContentBody>
    );
  };

  const StatusContentBodyItem = ({children}) => {
    return (
        <StyledStatusContentBodyItem className={"m-2 p-2"}>
          {children}
        </StyledStatusContentBodyItem>
    );
  };

  const FireContent = ({children, height}) => {
    return (
        <StyledFireContent height={height}>
          {children}
        </StyledFireContent>
    );
  };

  const FireContentBody = ({children, height}) => {
    return (
        <StyledFireContentBody height={height}>
          {children}
        </StyledFireContentBody>
    );
  }

  const contentRef = useRef(null);
  const faultRef = useRef(null);
  const fireRef = useRef(null);
  const sumFaultRef = useRef(null);
  const fireTitleRef = useRef(null);

  const [contentHeight, setContentHeight] = useState(0);
  const [faultHeight, setFaultHeight] = useState(0);
  const [fireHeight, setFireHeight] = useState(0);
  const [sumFaultHeight, setSumFaultHeight] = useState(0);
  const [fireTitleHeight, setFireTitleHeight] = useState(0);
  const [fireBodyHeight, setFireBodyHeight] = useState(0);

  useEffect(() => {
    setFireBodyHeight(contentHeight - sumFaultHeight - faultHeight - fireTitleHeight - 100);
  }, [contentHeight]);

  useLayoutEffect(() => {
    setContentHeight(contentRef.current.clientHeight);
    setFaultHeight(faultRef.current.clientHeight);
    setFireHeight(fireRef.current.clientHeight);
    setSumFaultHeight(sumFaultRef.current.clientHeight);
    setFireBodyHeight(contentHeight - sumFaultHeight - faultHeight - fireTitleHeight - 100);
  }, []);

  useEffect(() => {
    console.log(`contentHeight: ${contentHeight}`);
  }, [contentHeight]);
  useEffect(() => {
    console.log(`faultHeight: ${faultHeight}`);
  }, [faultHeight]);
  useEffect(() => {
    console.log(`fireHeight: ${fireHeight}`);
  }, [fireHeight]);
  useEffect(() => {
    console.log(`fireBodyHeight: ${fireBodyHeight}`);
  }, [fireBodyHeight]);

  useEffect(() => {
    function handleWindowResize() {
      setContentHeight(contentRef.current.clientHeight);
      setFaultHeight(faultRef.current.clientHeight);
      setFireHeight(fireRef.current.clientHeight);
      setSumFaultHeight(sumFaultRef.current.clientHeight);
      setFireBodyHeight(fireRef.current.clientHeight - fireTitleRef.current.clientHeight);
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);


  return (
      <div ref={contentRef} className={"content"}>
        <StatusContent height={"96vh"}>
          <StatusContentBody>
            <div ref={fireRef} className={"status"}>
              <StatusContentBodyItem>
                <FireContent height={`${contentHeight - sumFaultHeight - faultHeight - 50}px`}>
                  <TitleBar title={`화재 발생 현황`} ref={fireTitleRef}/>
                  {/*<FireContentBody height={`${contentHeight - sumFaultHeight - faultHeight - fireTitleHeight - 100}px`}>*/}
                  <FireContentBody height={`${fireBodyHeight}px`}>
                    {cardData?.fireList.map((elem, idx) => {
                      if (cardData.fireList.length === 0 || cardData.fireList.length === 1 || cardData.fireList.length === 2) {
                        return (
                            <DashCardView
                                key={idx}
                                propDate={elem.ocrn_dt_str ? elem.ocrn_dt_str : "최근 30일"}
                                propText2={`${elem.fclty_nm}`}
                                propLength={cardData.fireList.length}
                            />
                        );
                      } else {
                        if (parseInt(fireBodyHeight / 100) > idx + 1) {
                          // console.log(parseInt(fireBodyHeight / 100), idx);
                          // console.log(cardData.fireList.length);
                          return (
                              <DashCardView
                                  key={idx}
                                  propDate={elem.ocrn_dt_str ? elem.ocrn_dt_str : "최근 30일"}
                                  propText2={`${elem.fclty_nm}`}
                                  propLength={cardData.fireList.length}
                              />
                          );
                        }
                      }
                    })}

                    {cardData?.fireList.length === 0 ? (
                        <Card
                            bg={'dark'}
                            key={'dark'}
                            border="light"
                            className={"h-100"}
                        >
                          <Card.Body className={'text-center'}>
                            <Row className={"d-flex align-items-center h-100"}>
                              <Col md={12} className={"fs-3 my-auto"}>
                                최근 30일
                              </Col>
                              <Col md={12} className={"fs-2 fw-bold my-auto"}>
                                화재발생 없음
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                    ) : null}
                  </FireContentBody>
                </FireContent>
              </StatusContentBodyItem>
            </div>

            <div ref={sumFaultRef} className={"status"}>
              <StatusContentBodyItem>
                <TitleBar title={"누적 장애 현황"}/>
                <Row>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'crit'}
                        propText={'Critical'}
                        propText2={`${cardData?.faultSumList[0]?.cr ? cardData?.faultSumList[0]?.cr : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'major'}
                        propText={'Major'}
                        propText2={`${cardData?.faultSumList[0]?.mj ? cardData?.faultSumList[0]?.mj : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'minor'}
                        propText={'Minor'}
                        propText2={`${cardData?.faultSumList[0]?.mn ? cardData?.faultSumList[0]?.mn : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>

                </Row>
              </StatusContentBodyItem>
            </div>

            <div ref={faultRef} className={"status"}>
              <StatusContentBodyItem>
                <TitleBar title={"일일 장애 현황"}/>
                <Row>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'crit'}
                        propText={'Critical'}
                        propText2={`${cardData?.faultList[0]?.cr ? cardData?.faultList[0]?.cr : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'major'}
                        propText={'Major'}
                        propText2={`${cardData?.faultList[0]?.mj ? cardData?.faultList[0]?.mj : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>
                  <Col>
                    <CardView
                        propType={"fault"}
                        // propLevel={'minor'}
                        propText={'Minor'}
                        propText2={`${cardData?.faultList[0]?.mn ? cardData?.faultList[0]?.mn : '0'}`}
                        propLineBreak={true}
                        propAnonAPI={propAnonAPI}
                    />
                  </Col>

                </Row>
              </StatusContentBodyItem>
            </div>
          </StatusContentBody>
        </StatusContent>
      </div>
  );
};

export default DashFailureCards;